import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import Select from 'react-select';
import Switch from "react-switch";
import { toast } from 'react-toastify';

import { CustomCard } from "../../../components/Card/CustomCard";
import EstudiantesDisp from "./EstudiantesDisp";

import { ConsultCarreras} from '../../../funciones/ModalidadesFunction';
import { ConsultaSemestres} from '../../../funciones/CalifDirFunction';
import { ConsultaSecciones } from "../../../funciones/CobranzasFunction";

import { CortesDisp, EstSecc, AllEstSecc } from "../../../funciones/CobranzasFunction";

class Deserciones extends Component {
    state = {
        valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
        carreras: [],
        loadCarreras: true,
        valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
        semestres: [],
        loadSemestre: false,
        valorSeccion: { value: '', label: '- Selecciona una Sección -', prof: '', profEmail: '' },
        secciones: [],
        loadSeccion: false,
        preloader: <div className="text-danger">Selecciona una Carrera para comenzar</div>,
        estudiantes: [],
        check: false,
        cortes:[],
        valorCortes: { value: '', label: '- Selecciona un Corte -', prof: '', profEmail: '' },
        loadCortes: true,
        allDisabled: false,
        icon: "",
        verSinNotas: false
    }

    componentDidMount = () => {
        ConsultCarreras ((resp) => {
            this.setState({
                carreras: resp,
                loadCarreras: false,
            })
        })

        CortesDisp ((resp) => {
            this.setState({
                cortes: resp,
                loadCortes: false,
            })
        })
    }

    valorSelectCarrera = (valorCarrera) => {
        this.setState({
            valorCarrera,
            valorSemestre: { value: '', label: '- Cargando Semestres -' },
            valorSeccion: { value: '', label: '- Selecciona una Sección -' },
            secciones: [],
            semestres: [],
            preloader: <div className="text-danger">Selecciona una Semestre para continuar</div>,
            loadSemestre: true
        }, () => {
            ConsultaSemestres(valorCarrera.value, (resp) => {
                this.setState({
                    semestres: resp[0],
                    valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
                    loadSemestre: false
                })
            })
        });
    }

    valorSelectSemestre = (valorSemestre) => {
        this.setState({
            valorSemestre,
            valorSeccion: { value: '', label: '- Cargando Secciones -' },
            estudiantes: [],
            preloader: <div className="text-danger">Selecciona una Sección para continuar</div>,
            loadSeccion: true,
        }, () => {
            ConsultaSecciones(valorSemestre.value, (resp) => {
                this.setState({
                    secciones: resp[0],
                    valorSeccion: { value: '', label: '- Selecciona una Sección -' },
                    loadSeccion: false,
                })
            })
        });
    }

    valorSelectSeccion = (valorSeccion) => {
        this.setState({
            valorSeccion,
            preloader: <div className="text-danger"><i className="fa fa-spinner fa-spin"></i> Cargando Estudiantes</div>,
        }, () => {
            EstSecc (valorSeccion.value, (resp) => {
                let pre = "";
                if (resp.length === 0) pre = <div className="text-danger">No existen estudiantes en esta sección</div>
                this.setState({
                    estudiantes: resp,
                    preloader: pre
                })
            })
        });
    }

    cambiarCheck = () => {
        if (this.state.valorCortes.value === "" && this.state.check === false) {
            toast.error("Debes selecionar un Corte primero",{autoClose: 4000});
            return null;
        }

        this.setState({
            check: !this.state.check,
            preloader: <div className="text-danger"><i className="fa fa-spinner fa-spin"></i> Cargando Estudiantes</div>,
            estudiantes: [],
            valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
            valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
            semestres: [],
            valorSeccion: { value: '', label: '- Selecciona una Sección -', prof: '', profEmail: '' },
            secciones: [],
        }, () => {
            this.setState({
                allDisabled: this.state.check
            }, () => {
                if (this.state.check === false){
                    this.setState({
                        preloader: <div className="text-danger">Selecciona una Carrera para comenzar</div>,
                    })
                }else{
                    AllEstSecc(this.state.valorCortes.value, (resp) => {
                        let pre = "";
                        if (resp.length === 0) pre = <div className="text-danger">No existen estudiantes sin calificaciones</div>
                        this.setState({
                            estudiantes: resp,
                            preloader: pre
                        })
                    })
                }
            })
        })
    }

    cambiarCheckSn = () => {
        this.setState({
            verSinNotas: !this.state.verSinNotas
        });
    }

    valorSelectCortes = (valorCortes) => {
        if (this.state.check === false){
            this.setState({ valorCortes })
        }else{
            this.setState({
                valorCortes,
                preloader: <div className="text-danger"><i className="fa fa-spinner fa-spin"></i> Cargando Estudiantes</div>,
                estudiantes: [],
                valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
                valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
                semestres: [],
                valorSeccion: { value: '', label: '- Selecciona una Sección -', prof: '', profEmail: '' },
                secciones: [],
            }, () => {
                AllEstSecc(valorCortes.value, (resp) => {
                    let pre = "";
                    if (resp.length === 0) pre = <div className="text-danger">No existen estudiantes sin calificaciones</div>
                    this.setState({
                        estudiantes: resp,
                        preloader: pre
                    })
                })
            })
        }
    }

    refresh = () => {
        let { check, valorCortes, valorSeccion } = this.state;

        if (check === true){
            AllEstSecc(valorCortes.value, (resp) => {
                let pre = "";
                if (resp.length === 0) pre = <div className="text-danger">No existen estudiantes sin calificaciones</div>
                this.setState({
                    estudiantes: resp,
                    preloader: pre
                })
            })
        }else{
            EstSecc (valorSeccion.value, (resp) => {
                let pre = "";
                if (resp.length === 0) pre = <div className="text-danger">No existen estudiantes en esta sección</div>
                this.setState({
                    estudiantes: resp,
                    preloader: pre
                })
            })
        }
    }

    contenido = () => {
        let { valorCarrera, carreras, valorSemestre, semestres, valorSeccion, secciones, preloader, estudiantes,
            check, cortes, valorCortes, allDisabled, loadCarreras, loadSemestre, loadSeccion, loadCortes,
            icon, verSinNotas } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let contentEst = () => {
            if (estudiantes.length === 0) return (
                <div className="custom-mt-10" align="center">{preloader}</div>
            )

            return(
                <React.Fragment>
                    <div>
                        <Switch
                            height={12}
                            width={24}
                            onChange={this.cambiarCheckSn}
                            checked={verSinNotas}
                        />
                        <span style={{fontSize: 12, }}> <strong>Resaltar estudiantes sin notas en ningún corte</strong></span>
                    </div>
                    <div className="table-responsive" id="lisEstDeser" onScroll={this.update} style={{overflowY: "auto", maxHeight: "30vh"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="100%" style={styles}><strong>Estudiante</strong></td>
                                    <td width="200px" align="center" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                { estudiantes.map(option => (
                                    <EstudiantesDisp key={option.id} datos = {option} resaltar={verSinNotas}
                                    funcionRefresh = { this.refresh }/> 
                                )) }
                            </tbody>
                        </Table>
                        <div align="center"><i className={icon}></i></div>
                    </div>
                </React.Fragment>
            )
        }

        return(
            <React.Fragment>
                <div className="custom-alert-danger">
                    <Row>
                        <Col md={8} align="justify" style={{marginTop: 12}}>
                            <Switch
                                height={12}
                                width={24}
                                onChange={this.cambiarCheck}
                                checked={check}
                            />
                            <span style={{fontSize: 12, fontWeight: "bold"}}> Ver estudiantes sin calificaciones en el corte</span>
                        </Col>
                        <Col md={4}>
                            <Select
                                isSearchable ={true}
                                value={valorCortes}
                                onChange={this.valorSelectCortes}
                                options={cortes}
                                isLoading={loadCortes}
                            />
                        </Col>
                    </Row>
                </div>

                <hr/>

                <div className="custom-alert-info custom-mt-10">
                    <Row>
                        <Col md={6}>
                            <Select
                                isDisabled = {allDisabled}
                                isSearchable ={true}
                                value={valorCarrera}
                                onChange={this.valorSelectCarrera}
                                options={carreras}
                                isLoading={loadCarreras}
                            />
                            <span style={{fontSize: 10}}>Carreras</span>
                        </Col>
                        <Col md={6}>
                            <Select
                                isDisabled = {allDisabled}
                                isSearchable ={true}
                                value={valorSemestre}
                                onChange={this.valorSelectSemestre}
                                options={semestres}
                                isLoading={loadSemestre}
                            />
                            <span style={{fontSize: 10}}>Semestres</span>
                        </Col>
                    </Row>
                </div>

                <div className="custom-alert-warning custom-mt-10">
                    <Row>
                        <Col md={9}>
                            <Select
                                isDisabled = {allDisabled}
                                isSearchable ={true}
                                value={valorSeccion}
                                onChange={this.valorSelectSeccion}
                                options={secciones}
                                isLoading={loadSeccion}
                            />
                            <span style={{fontSize: 10}}>Secciones Disponibles</span>
                        </Col>
                        <Col md={3} align="right">
                            <button title="Imprimir el listado de los estudiantes de la sección" className="btn btn-relleno-danger" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                        </Col>
                    </Row>
                </div>

                <div className="custom-mt-10">{contentEst()}</div>
            </React.Fragment>
        );
    }

    ayuda = () => (
        <React.Fragment>
            <div align ="justify">
                En esta sección podrás realizar el retiro de los estudiantes.
            </div>
            <div className="custom-mt-10" align="justify">
                La opción <strong className="text-danger">Ver estudiantes sin calificaciones en el corte</strong> permite ver el listado de estudiantes que no poseen calificaciones durante el corte seleccionado.
            </div>
            <div className="custom-mt-10" align="justify">
                También puedes buscar un estudiante por sección, seleccionando La Carrera, El Semestre y la Sección
            </div>
            <div className="custom-mt-10" align="justify">
                Al habilitar la opción <Switch height={12} width={24} checked={false} /> <strong>Resaltar estudiantes sin notas en ningún corte.</strong> Ubicado sobre el listado de estudiantes, se resaltarán los estudiantes que no poseen calificaciones en ninguno de los cortes
            </div>
            <div className="custom-mt-10" align="justify">
                Para <strong>Retirar</strong> un estudiante presiona el botón <button className="btn btn-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-sign-out"></i></button> ubicado al lado derecho del estudiante y confirma para efectuar el retiro.
            </div>
            <div className="custom-mt-10" align="justify">
                <strong>Importante: Esta función NO ELIMINA al estudiante de la Base de Datos. Sólo efectúa el retiro por lo que su estado de cuenta, sus datos personales y su archivo histporico se mantienen</strong>
            </div>
        </React.Fragment>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Retiros y Deserciones</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default Deserciones;


// WEBPACK FOOTER //
// ./src/views/Administracion/CobranzasContent/Deserciones.jsx